import { logger, NetworkState } from "@mwt/web-js-telemetry";
import dayjs from "dayjs";
import { GraphQLError } from "graphql";
import utc from "dayjs/plugin/utc";

import { DataBagHttpColumns, EventType } from "./constants";

dayjs.extend(utc);

export type trackNonUIEventParams = {
  durationInMs: number;
  correlationId: string;
  operationName: string;
  error: GraphQLError | Error;
  requestResult: string;
  eventStartTime: dayjs.Dayjs;
  resultCode: number;
  contentLength: string;
  url: string;
  errorType?: string;
  errorSubType?: string;
};

export const trackNonUIEvent = ({
  durationInMs,
  correlationId,
  operationName,
  error,
  requestResult,
  eventStartTime,
  resultCode,
  contentLength,
  url,
  errorType = "",
  errorSubType = "",
}: trackNonUIEventParams) => {
  logger.logHttpRequestEvent(
    {
      hostname: window.location.hostname,
      duration: durationInMs,
      requestResult,
      resultCode,
      contentLength,
      requestCreatedTime: dayjs(eventStartTime).utc().format(),
      networkState: window.navigator?.onLine
        ? NetworkState.Online
        : NetworkState.Offline,
      databag: {
        [DataBagHttpColumns.DataBagIsSuccessful]: false,
        [DataBagHttpColumns.DataBagCorrelationId]: correlationId,
        [DataBagHttpColumns.DataBagUrl]: operationName,
        [DataBagHttpColumns.DataBagReason]: error.message,
        [DataBagHttpColumns.DataBagServiceUrl]: url,
        [DataBagHttpColumns.DataBagErrorType]: errorType,
        [DataBagHttpColumns.DatabBagErrorSubType]: errorSubType,
      },
    },
    EventType.NonUiEvent
  );
};
